export const RETURN_OBJECTS = {
  returnObjects: true,
}
